import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useProvince } from "@/contexts/ProvinceContext";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const { provinces } = useProvince();
  const nav = useNavigate();
  const [f, setF] = useState({
    email: "", username: "", password: "", first_name: "", last_name: "",
    province_id: "", phone: "", birth_date: "",
    accepted_kvkk: false, accepted_terms: false,
  });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!f.accepted_kvkk || !f.accepted_terms) return toast.error("Lütfen KVKK ve kullanım şartlarını onaylayın");
    setLoading(true);
    try {
      await register({ ...f, province_id: f.province_id || null });
      toast.success("Kayıt başarılı!");
      nav("/");
    } catch (err) { toast.error(err.response?.data?.detail || "Kayıt başarısız"); }
    finally { setLoading(false); }
  };

  const upd = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-8">
      <form data-testid="register-form" onSubmit={submit} className="bg-white border border-gray-100 rounded-lg p-8 shadow-sm w-full max-w-xl">
        <div className="flex justify-center mb-5"><Logo size="lg" /></div>
        <h1 className="text-2xl font-black text-center mb-1">Üye Ol</h1>
        <p className="text-sm text-gray-500 text-center mb-6">Hesabınızı oluşturup SİNE81 topluluğuna katılın</p>
        <div className="grid md:grid-cols-2 gap-3">
          <Inp label="Email" type="email" value={f.email} onChange={upd("email")} required testid="reg-email" />
          <Inp label="Kullanıcı Adı" value={f.username} onChange={upd("username")} required testid="reg-username" />
          <Inp label="Şifre" type="password" value={f.password} onChange={upd("password")} required testid="reg-password" />
          <Inp label="Telefon" value={f.phone} onChange={upd("phone")} />
          <Inp label="İsim" value={f.first_name} onChange={upd("first_name")} />
          <Inp label="Soyisim" value={f.last_name} onChange={upd("last_name")} />
          <div>
            <label className="block text-sm font-medium mb-1">İl</label>
            <select value={f.province_id} onChange={upd("province_id")} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm">
              <option value="">Seçiniz</option>
              {provinces.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
          <Inp label="Doğum Tarihi" type="date" value={f.birth_date} onChange={upd("birth_date")} />
        </div>
        <div className="mt-4 space-y-2 text-sm">
          <label className="flex items-start gap-2"><input data-testid="reg-kvkk" type="checkbox" checked={f.accepted_kvkk} onChange={upd("accepted_kvkk")} className="mt-0.5" /><span><Link to="/kurumsal/kvkk" target="_blank" className="text-[#e11d2a]">KVKK Aydınlatma Metni</Link>'ni okudum ve onaylıyorum.</span></label>
          <label className="flex items-start gap-2"><input data-testid="reg-terms" type="checkbox" checked={f.accepted_terms} onChange={upd("accepted_terms")} className="mt-0.5" /><span><Link to="/kurumsal/kullanim-sartlari" target="_blank" className="text-[#e11d2a]">Kullanım Şartları</Link> ve <Link to="/kurumsal/gizlilik" target="_blank" className="text-[#e11d2a]">Gizlilik Politikası</Link>'nı kabul ediyorum.</span></label>
        </div>
        <button data-testid="reg-submit" type="submit" disabled={loading} className="w-full mt-5 px-4 py-2.5 bg-[#e11d2a] text-white rounded-md font-semibold">{loading ? "Üyelik oluşturuluyor..." : "Üye Ol"}</button>
        <div className="mt-4 text-sm text-center">Zaten üye misiniz? <Link to="/giris" className="text-[#e11d2a] font-semibold">Giriş Yap</Link></div>
      </form>
    </div>
  );
}

const Inp = ({ label, testid, ...rest }) => (
  <div>
    <label className="block text-sm font-medium mb-1">{label}</label>
    <input data-testid={testid} {...rest} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm" />
  </div>
);
